<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'
import { computed } from 'vue'
import LogoFooter from '@/components/LogoFooter.vue'
import { X } from 'lucide-vue-next'

const props = defineProps({
  title: String,
  text: String
})
const decodedText = computed(() => {
  const decoded = decodeURIComponent(JSON.parse(`${props.text}`))
  const parser = new DOMParser()
  const doc = parser.parseFromString(decoded, 'text/html')
  doc.querySelectorAll('a').forEach((a) => {
    a.setAttribute('target', '_blank')
  })
  return doc.body.innerHTML
})
const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <VueFinalModal
    content-class="absolute bottom-0 w-full p-4 pb-0 bg-white dark:bg-white space-y-2 rounded-t-xl "
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    @update:model-value="(val) => emit('update:modelValue', val)"
  >
    <div
      class="flex w-full h-full flex-col w-full max-w-xl mx-auto p-4 rounded-lg space-y-2 max-h-[80vh]"
    >
      <div class="inset-0 overflow-auto rounded-t-xl">
        <button @click="emit('update:modelValue', false)" class="absolute top-0 right-0 p-4">
          <X />
        </button>
        <div class="flex flex-col my-5 mx-auto p-4 bg-white space-y-2 rounded-t-xl">
          <h1 class="text-lg font-bold">
            {{ title }}
          </h1>
          <p class="prose prose-content text-sm" v-html="decodedText" />
        </div>
        <LogoFooter :dark-logo="true" />
      </div>
    </div>
  </VueFinalModal>
</template>
